export enum GenderChoice {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
